import {getEmployeeByBatch, guardSearchEmployee} from "@/api/organize-api";

export const to_employee_mixin = {
    data() {
        return {
            searchLoading: false,
            employeeList: [],
        }
    },

    methods: {

        requestBindEmployee(contactEmployeeCode) {
            if (!contactEmployeeCode) {
                this.employeeList = []
                return
            }
            getEmployeeByBatch([contactEmployeeCode]).then(({data}) => {
                if (data.code === 200 && data.data.length > 0) {
                    let employee = data.data[0]
                    this.$set(this.selectVisitor, "contactEmployee", employee)
                    this.employeeList = data.data
                }
            }).catch((err) => {
                this.logE("VisitCodeCome getEmployeeByCode err", err)
            })
        },

        employeeFilter(query) {
            if (!query) {
                this.employeeList = []
                return
            }
            this.searchLoading = true
            guardSearchEmployee({name: query}).then(({data}) => {
                if (data.code === 200) {
                    this.employeeList = data.data
                }
                this.searchLoading = false
            }).catch(err => {
                console.log(err)
                this.searchLoading = false
            })
        },
    },

    computed: {},

}
